module.exports = __webpack_public_path__ + "img/mxl.5880d0ed.png";